import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {Button} from '@/shadcn_components/ui/button';
import TextareaInput from '@/components/refinedev/TextareaInput';
import {Send} from 'lucide-react';
import {Avatar, AvatarFallback, AvatarImage} from '@/shadcn_components/ui/avatar';
import useLoginStore from '@/store/useLoginStore';

const schema = yup.object({
  message: yup.string().required('Message is required'),
});

type FormValues = {
  message: string;
};

interface ChatMessageFormProps {
  onSubmit: (data: FormValues) => void;
  isLoading?: boolean;
}

export const CommentInputForm = ({onSubmit, isLoading = false}: ChatMessageFormProps) => {
  const userIdentity = useLoginStore(state => state.userdata);

  const form = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      message: '',
    },
  });

  const handleSubmit = (data: FormValues) => {
    onSubmit(data);
    form.reset();
  };

  return (
    <div className={'flex flex-col gap-1'}>
      <div className={'flex gap-4'}>
        <Avatar className={'w-[32px] h-[32px]'}>
          <AvatarImage src={userIdentity?.avatarUrl} />
          <AvatarFallback>CN</AvatarFallback>
        </Avatar>
        <div className={`flex flex-col w-full`}>
          <div className={'min-h-[30px] rounded-lg s-comment-card border'}>
            <FormProvider {...form}>
              <form
                onSubmit={form.handleSubmit(handleSubmit)}
                className="flex flex-row items-center gap-4">
                <TextareaInput source="message" placeholder='Nhập trao đổi/bình luận' />
                <Button type="submit" disabled={isLoading} className="">
                  <Send className="w-4 h-4 mr-2" />
                </Button>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommentInputForm;
